import { ERecurrencyType } from "../../interfaces/MyPlans/IMyPlans";

export function convertRecurrencyType(recurrency_type: ERecurrencyType) {
  let recurrencyType = recurrency_type || ERecurrencyType.MONTHLY;
  const recurrencyMap = {
    [ERecurrencyType.UNIQUE]: "global.recurrence_type.unique",
    [ERecurrencyType.MONTHLY]: "global.recurrence_type.monthly",
    [ERecurrencyType.QUATERLY]: "global.recurrence_type.quarterly",
    [ERecurrencyType.BIMONTHLY]: "global.recurrence_type.bimonthly",
    [ERecurrencyType.SEMI_ANNUALY]: "global.recurrence_type.semi_annual",
    [ERecurrencyType.ANNUAL]: "global.recurrence_type.annual",
    [ERecurrencyType.BI_ANNUAL]: "global.recurrence_type.bi_annual",
  };
  return recurrencyMap[recurrencyType];
}
